import { compose } from 'recompose';

import CaseStudyShow from './CaseStudyShow';

const enhance = compose();

export default enhance(CaseStudyShow);
